import { PluginKey } from '@atlaskit/editor-prosemirror/state';

import type { AgentEditChromeState } from './types';

export const agentEditChromePluginKey: PluginKey<AgentEditChromeState> =
	new PluginKey<AgentEditChromeState>('agentEditChrome');
